module.exports = __webpack_public_path__ + "media/brands/new-2a4de131.svg";